module.exports = __webpack_public_path__ + "img/device_c6s_one_en.55c8dbae.png";